import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { addToHomeScreen } from '../utils/data';
import { ThemedElement } from './themed-element';
let AppInstall = class AppInstall extends ThemedElement {
    static get styles() {
        return [
            ...super.styles,
            css `
        .bottom-drawer-link {
          padding: 16px 24px;
          cursor: pointer;
        }
      `,
        ];
    }
    constructor() {
        super();
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            this.deferredPrompt = e;
        });
    }
    render() {
        return html `
      <a class="bottom-drawer-link" @click="${this.prompt}" ?hidden=${!this.deferredPrompt}>
        ${addToHomeScreen.cta}
      </a>
    `;
    }
    async prompt() {
        if (!this.deferredPrompt) {
            return;
        }
        this.deferredPrompt.prompt();
        this.deferredPrompt = undefined;
    }
};
__decorate([
    state()
], AppInstall.prototype, "deferredPrompt", void 0);
AppInstall = __decorate([
    customElement('app-install')
], AppInstall);
export { AppInstall };
//# sourceMappingURL=app-install.js.map